import React from "react";

import { RichTextEditor } from "./RichTextEditor";

interface Props {
  markdown: string;
}

export const TextBlock: React.FC<Props> = ({ markdown }) => {
  return (
    <div className="themed-text-block-card p-3 sm:p-4 md:p-6 h-full flex flex-col rounded-themed overflow-auto">
      <RichTextEditor
        key={markdown}
        initialMarkdown={markdown}
        editable={false}
        showToolbar={false}
        className="h-full"
        namespace="TextBlockViewer"
        contentClassName="text-text-block-foreground text-base"
      />
    </div>
  );
};
